import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-4 pt-5 pb-4 text-2xl text-[#545656]" }
const _hoisted_2 = { class: "font-semibold" }


export default /*@__PURE__*/_defineComponent({
  __name: 'TextButton',
  props: {
        title: String,
        link: String,
    },
  setup(__props) {

    const props = __props

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("h2", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: props.link ? props.link : '',
      class: "hover:text-[#db0720]"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(props.title), 1),
        _cache[0] || (_cache[0] = _createTextVNode(" - Management Tool 2.0 ", -1))
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})